export default __webpack_public_path__ + "static/media/icon-ev.034550f4.svg";